import angular from 'angular';
import f from 'odata-filter-builder';
import { transformODataResponse } from 'utilities/query';
import templateUrl from './report-form.html';

export default {
  templateUrl,
  bindings: {
    onReportGenerated: '&'
  },
  controller: class ReportFormComponent {
    constructor(EventEmitter,
      AnimalTypeService,
      CategoryService,
      CompanyService,
      IngredientService,
      ProductService,
      ReportService,
      SessionService,
      ToastService) {
      'ngInject';

      Object.assign(this, {
        EventEmitter,
        AnimalTypeService,
        CategoryService,
        CompanyService,
        IngredientService,
        ProductService,
        ReportService,
        SessionService,
        ToastService
      });
    }

    $onInit() {
      this.params = this.SessionService.reportParams || {};
      this.params.ingredientIds = this.params.ingredientIds || [];
      this.params.memberIds = this.params.memberIds || [];
      this.params.productIds = this.params.productIds || [];

      this.CategoryService.search({
        orderBy: 'ProductCategoryName',
        direction: 'asc'
      }).then((r) => {
        this.categories = transformODataResponse(r).Data;
      }).catch(error => this.ToastService.showError(error));

      this.AnimalTypeService.getAnimalTypes().then((r) => {
        this.animalTypes = r.data;
      }).catch(error => this.ToastService.showError(error));

      this.years = this.ReportService.getYears();
    }

    transformChip(chip) {
      if (angular.isObject(chip)) {
        return chip;
      }

      return { name: chip, type: 'new' };
    }

    searchMembers(memberName) {
      return this.CompanyService.search({
        orderBy: 'MemberName',
        direction: 'asc',
        filter: f().contains('MemberName', memberName)
      }).then(r => transformODataResponse(r).Data)
        .catch(error => this.ToastService.showError(error));
    }

    searchProducts(productName) {
      return this.ProductService.search({
        orderBy: 'ProductName',
        direction: 'asc',
        filter: f().contains('ProductName', productName)
      }).then(r => transformODataResponse(r).Data)
        .catch(error => this.ToastService.showError(error));
    }

    searchIngredients(ingredientName) {
      return this.IngredientService.searchSystemIngredients({
        orderBy: 'SystemIngredientName',
        direction: 'asc',
        filter: f().contains('SystemIngredientName', ingredientName)
      }).then(r => transformODataResponse(r).Data)
        .catch(error => this.ToastService.showError(error));
    }

    resetForm() {
      this.reportForm.$setPristine();
      this.reportForm.$setUntouched();
      this.params = {};
      this.params.ingredientIds = [];
      this.params.memberIds = [];
      this.params.productIds = [];
      this.persistParams();
    }

    persistParams() {
      this.SessionService.reportParams = this.params;
    }

    onSubmit(params) {
      this.persistParams();
      this.onReportGenerated(
        this.EventEmitter({
          params: {
            ...params,
            ingredientIds: (params.ingredientIds && params.ingredientIds
              .map(ingredient => ingredient.SystemIngredientId)) || [],
            productIds: (params.productIds && params.productIds.map(product => product.ProductId)) || [],
            memberIds: (params.memberIds && params.memberIds.map(product => product.MemberId)) || []
          }
        })
      );
    }

    toggleYears() {
      if (this.allYearsSelected) {
        this.allYearsSelected = false;
        this.params.yearIds = [];
      } else {
        this.allYearsSelected = true;
        this.params.yearIds = this.years;
      }
    }

    toggleCategories() {
      if (this.allCategoriesSelected) {
        this.allCategoriesSelected = false;
        this.params.productCategoryIds = [];
      } else {
        this.allCategoriesSelected = true;
        this.params.productCategoryIds = this.categories.map(c => c.ProductCategoryId);
      }
    }

    toggleSpecies() {
      if (this.allSpeciesSelected) {
        this.allSpeciesSelected = false;
        this.params.specieIds = [];
      } else {
        this.allSpeciesSelected = true;
        this.params.specieIds = this.animalTypes.map(c => c.AnimalTypeId);
      }
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/reports/report-form/report-form.component.js